import { render, staticRenderFns } from "./ExerciseRecord.vue?vue&type=template&id=464ee80f&scoped=true"
import script from "./ExerciseRecord.vue?vue&type=script&lang=js"
export * from "./ExerciseRecord.vue?vue&type=script&lang=js"
import style0 from "./ExerciseRecord.vue?vue&type=style&index=0&id=464ee80f&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464ee80f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('464ee80f')) {
      api.createRecord('464ee80f', component.options)
    } else {
      api.reload('464ee80f', component.options)
    }
    module.hot.accept("./ExerciseRecord.vue?vue&type=template&id=464ee80f&scoped=true", function () {
      api.rerender('464ee80f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/inspect/ExerciseRecord.vue"
export default component.exports